// appels/detail hooks
import { queryOptions, useQuery } from "@tanstack/react-query";
import { STALE_TIME } from "@core/libs/react-query";
import { appelKeys } from "../../_shared/keys";
import { getAppel } from "../services";

/**
 * One appel. Shared by the route (which loads it before the page opens) and the screens, so both
 * read one cache entry. `operational` tier, and never retried on a 404.
 */
export function appelQueryOptions(id: string) {
  return queryOptions({
    queryKey: appelKeys.detail(id),
    queryFn: () => getAppel(id),
    staleTime: STALE_TIME.operational,
    retry: false,
  });
}

export function useAppel(id: string) {
  return useQuery(appelQueryOptions(id));
}
